import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {FirmaExtendedReadResponseDTO} from '../../openapi/partner-openapi';


export const firmaEntitiesAdapter: EntityAdapter<FirmaExtendedReadResponseDTO> = createEntityAdapter<FirmaExtendedReadResponseDTO>({
  selectId: (entity: FirmaExtendedReadResponseDTO) => entity.firmaId,
});
